import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';
import { DateRangeInterval } from '../../../core/components/date-range/date-range.component';

@Component({
  selector: 'tt-receivables',
  templateUrl: './receivables.component.html',
  styleUrls: ['./receivables.component.css']
})
export class ReceivablesComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public grid?: GridOptions;

    public getting = false;

    constructor(private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(3004))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_receivables_grid').setLoadDataFunction({ method: 3006, parameters: () => this.setting }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async getChanges() {
        if (!!this.setting) {
            try {
                this.getting = true;

                const response = (await this.datatask.Post(3005, this.setting))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                }
            } finally {
                this.getting = false;
            }
        }
    }

    public onTabChange() {
        this.loadGrid();
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    public onDateRangeChanged() {
        this.loadGrid();
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    bg_receivables_main: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    date_fomtom: string;
}
